import { GET } from "./";
export const Countries = {
  getCountries: () => GET(`/api/country`),
  getRegionsByCountryId: (countryId) => GET(`/api/country/${countryId}/regions`),
  getCitiesByRegionId: (countryId, regionId) => GET(`/api/country/${countryId}/regions/${regionId}/cities`),
};
